import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { path: '/website', label: 'Home' },
  { path: '/website/features', label: 'Features' },
  { path: '/website/modules', label: 'Modules' },
  { path: '/website/about', label: 'About' },
];

export default function WebsiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'backdrop-blur-xl bg-[#0B0F19]/80 border-b border-white/10 shadow-2xl' : 'bg-transparent'
      }`}
      data-testid="website-nav"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-16">
        <Link to="/website" className="flex items-center gap-2.5" data-testid="website-logo-link">
          <img src="/sidebar-icon.png" alt="" className="h-8 w-8 rounded-md" />
          <span className="text-white font-bold text-lg tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
            ProjectBook Pro<sup className="text-[10px]">TM</sup>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map(l => (
            <Link
              key={l.path} to={l.path}
              className={`text-sm font-medium transition-colors ${
                location.pathname === l.path ? 'text-white' : 'text-slate-400 hover:text-white'
              }`}
              style={{ fontFamily: 'Manrope, sans-serif' }}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/demo?tab=signin"
            className="px-5 py-2 text-sm font-semibold text-slate-300 hover:text-white border border-white/15 hover:border-white/30 rounded-lg transition-all"
            style={{ fontFamily: 'Manrope, sans-serif' }}
            data-testid="nav-signin-btn"
          >
            Sign In
          </Link>
          <Link
            to="/demo"
            className="px-5 py-2 text-sm font-semibold text-white bg-[#3B82F6] hover:bg-[#2563EB] rounded-lg transition-all"
            style={{ fontFamily: 'Manrope, sans-serif' }}
            data-testid="demo-login-btn"
          >
            Try Live Demo
          </Link>
        </div>

        <button className="md:hidden text-white" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden backdrop-blur-xl bg-[#0B0F19]/95 border-t border-white/10 px-6 py-4 space-y-3">
          {NAV_LINKS.map(l => (
            <Link key={l.path} to={l.path} className="block text-sm font-medium text-slate-300 hover:text-white py-1">
              {l.label}
            </Link>
          ))}
          <Link to="/demo?tab=signin" className="block mt-2 px-4 py-2 text-sm font-semibold text-slate-300 border border-white/15 rounded-lg text-center">
            Sign In
          </Link>
          <Link to="/demo" className="block mt-2 px-4 py-2 text-sm font-semibold text-white bg-[#3B82F6] rounded-lg text-center">
            Try Live Demo
          </Link>
        </div>
      )}
    </nav>
  );
}
